// @ts-nocheck

const wordpressUI = (): void => {
  wp.domReady(() => {
    // Remove default image styles
    wp.blocks.unregisterBlockStyle('core/image', 'default');
    wp.blocks.unregisterBlockStyle('core/image', 'rounded');

    // Ensure button styles are properly registered
    // Unregister default styles first to avoid conflicts
    wp.blocks.unregisterBlockStyle('core/button', 'fill');
    wp.blocks.unregisterBlockStyle('core/button', 'outline');

    // Re-register button styles with proper configuration
    wp.blocks.registerBlockStyle('core/button', {
      name: 'fill',
      label: 'Fill',
      isDefault: true,
    });

    wp.blocks.registerBlockStyle('core/button', {
      name: 'outline',
      label: 'Outline',
    });
  });
};

export default wordpressUI;
